/**
 * SR Header Controller v1.0
 * 
 * 职责：
 * - 根据 SRController 的 member-changed 事件，更新 Header 上的 Explorer/Insider 文字
 * - 根据 SRController 的 cart-changed 事件，更新购物袋上的数字
 * 
 * 架构：
 * - V 层：只负责 DOM 更新，不做业务判断
 * - C 端：通过 SRController.on() 发送指令
 * - 所有页面共用这一个文件
 */

(function() {
  'use strict';

  // 检查 Controller 是否加载
  if (typeof SRController === 'undefined') {
    console.error('[SR-Header] SRController not found');
    return;
  }

  // ==================== Header 身份切换 ====================
  
  /**
   * 更新所有 Header 上的身份显示
   * @param {boolean} isInsider - 是否是会员
   */
  function updateIdentity(isInsider) {
    // 查找所有身份显示元素
    var els = document.querySelectorAll('[data-sr-identity]');
    
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (isInsider) {
        el.textContent = 'Insider ✦';
        el.style.fontWeight = '600';
        el.style.setProperty('text-decoration', 'none', 'important');
      } else {
        el.textContent = 'Explorer';
        el.style.fontWeight = '400';
        el.style.setProperty('text-decoration', 'underline', 'important');
      }
    }
  }

  // ==================== 购物袋数字更新 ====================
  
  /**
   * 更新购物袋上的数字
   * @param {number} count - 购物车商品数量
   */
  function updateCartCount(count) {
    var els = document.querySelectorAll('[data-sr-cart-count]');
    
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (count > 0) {
        el.textContent = count;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    }
  }

  // ==================== Explorer 注册链接显隐 ====================
  
  /**
   * 更新 Explorer 注册链接的显隐
   * @param {boolean} isInsider - 是否是会员
   */
  function updateJoinTriggers(isInsider) {
    var els = document.querySelectorAll('[data-sr-join-trigger]');
    
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      // 会员时隐藏，非会员时显示
      el.style.display = isInsider ? 'none' : '';
    }
  }

  // ==================== 注册回调 ====================
  
  // 会员状态变化 → 更新 Header 身份显示 + Explorer 链接显隐
  SRController.on('member-changed', function(payload) {
    var isInsider = payload && payload.data && payload.data.mid;
    updateIdentity(isInsider);
    updateJoinTriggers(isInsider);
  });

  // 购物车变化 → 更新购物袋数字
  SRController.on('cart-changed', function(payload) {
    var count = (payload && payload.data && payload.data.itemCount) || 0;
    updateCartCount(count);
  });

  // ==================== 初始化 ====================
  
  // 根据当前状态立即渲染一次
  var currentState = SRController.get();
  var isInsider = currentState && currentState.mid;
  updateIdentity(isInsider);
  updateJoinTriggers(isInsider);

  console.log('[SR-Header] v1.0.4 ready');
})();
